var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoSped01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3D9AE2;}\n\t.st1{fill:#5AAAE7;}\n\t.st2{fill:#96C8EF;}\n\t.st3{fill:#C2DFF6;}\n\t.st4{fill:#1E81CE;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1283",
    className: "st0",
    d: "M27.1,8.3v25.6c0,1-0.8,1.8-1.8,1.8c0,0,0,0,0,0H4.2c-1,0-1.8-0.8-1.8-1.8c0,0,0,0,0,0V8.3 c0-1,0.8-1.8,1.8-1.8h21.1C26.3,6.5,27.1,7.3,27.1,8.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1284",
    className: "st1",
    d: "M27.1,8.3v25H6.2c-1,0-1.8-0.8-1.8-1.8v-25h20.9C26.3,6.5,27.1,7.3,27.1,8.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1285",
    className: "st2",
    d: "M32.3,28.4l-20.1,6.1c-1,0.3-2-0.3-2.3-1.2L2.5,8.8c-0.3-1,0.3-2,1.2-2.3l0.4-0.1l19.8-6 c1-0.3,2,0.3,2.3,1.2l7.3,23.9l0.2,0.6C33.8,27.1,33.3,28.1,32.3,28.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1286",
    className: "st3",
    d: "M33.4,25.5l-19.8,6c-1,0.3-2-0.3-2.3-1.2L4.1,6.4l19.8-6c1-0.3,2,0.3,2.3,1.2L33.4,25.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1287",
    className: "st0",
    d: "M15.5,12.6c0.8,0.1,1.2,0.1,1.4,0.7c0.2,0.5,0,0.9-0.6,1c-0.3,0.1-0.7,0.1-1.1-0.1 c-0.2-0.1-0.4-0.2-0.6-0.1c-0.3,0.1-0.5,0.5-0.4,0.8c0.2,0.5,0.9,0.8,1.8,0.8l0.1,0.2c0.1,0.4,0.5,0.6,0.8,0.4 c0.4-0.1,0.6-0.5,0.4-0.8l0,0l-0.1-0.2c0.8-0.5,1.2-1.5,0.8-2.4c-0.3-1-1.3-1.7-2.4-1.6l-0.1,0c-0.7,0-1-0.1-1.2-0.5 c-0.1-0.2,0-0.4,0.1-0.5c0.2-0.1,0.3-0.2,0.5-0.3c0.3-0.1,0.6-0.1,0.8,0c0.1,0,0.3,0,0.4,0c0.3-0.1,0.5-0.5,0.4-0.8 c-0.2-0.6-1.1-0.5-1.5-0.4l-0.1-0.2c-0.1-0.4-0.5-0.6-0.8-0.5C14,8,13.8,8.4,13.9,8.8c0,0,0,0,0,0L14,9.1c-0.7,0.4-1,1.3-0.7,2.1 C13.7,12.5,14.7,12.5,15.5,12.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1288",
    className: "st0",
    d: "M26.4,15.7c-0.1-0.3-0.4-0.4-0.7-0.4L10.4,20c-0.3,0.1-0.4,0.4-0.4,0.7 c0.1,0.2,0.3,0.4,0.5,0.4c0.1,0,0.1,0,0.2,0L26,16.4C26.3,16.3,26.5,16,26.4,15.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1289",
    className: "st0",
    d: "M27.3,18.6c-0.1-0.3-0.4-0.4-0.7-0.4l-15.3,4.6c-0.3,0.1-0.4,0.4-0.4,0.7 c0.1,0.2,0.3,0.4,0.5,0.4c0.1,0,0.1,0,0.2,0l15.3-4.6C27.2,19.2,27.4,18.9,27.3,18.6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1290",
    className: "st0",
    d: "M28.2,21.6c-0.1-0.3-0.4-0.4-0.7-0.4l-15.3,4.6c-0.3,0.1-0.4,0.4-0.4,0.7 c0.1,0.2,0.3,0.4,0.5,0.4c0.1,0,0.1,0,0.2,0l15.3-4.6C28.1,22.2,28.3,21.9,28.2,21.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1291",
    className: "st0",
    d: "M29.1,24.5c-0.1-0.3-0.4-0.4-0.7-0.4l-15.3,4.6c-0.3,0.1-0.4,0.4-0.4,0.7 c0.1,0.2,0.3,0.4,0.5,0.4c0.1,0,0.1,0,0.2,0l15.3-4.6C29,25.1,29.2,24.8,29.1,24.5C29.1,24.5,29.1,24.5,29.1,24.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1292",
    className: "st4",
    d: "M10.8,4.4l-1,0.3C9.3,3.4,8,2.8,6.7,3.2c-1,0.3-1.6,1.2-1.6,2.3v6.2c0,0.8,0.6,1.4,1.4,1.4 s1.4-0.6,1.4-1.4V5.5c0-0.1,0-0.1,0-0.2C7.7,5.1,7.5,5,7.3,5.1C7.1,5.1,7,5.3,7,5.5v5.3c0,0.3-0.2,0.5-0.5,0.6S6,11.1,6,10.8 c0,0,0,0,0,0V5.5C6,4.6,6.6,4,7.5,4c0.6,0,1.2,0.4,1.4,1C8.9,5.1,9,5.3,9,5.5v6.2c0,1.4-1.1,2.5-2.5,2.5S4,13,4,11.7l0,0V5.4 C4,3.5,5.6,2,7.5,2C9,2,10.3,2.9,10.8,4.4L10.8,4.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSped01);
export default __webpack_public_path__ + "static/media/ico-sped-01.3217b59dcd6d2dae54eea9c279186e7b.svg";
export { ForwardRef as ReactComponent };